import styled from "styled-components";
import { Drawer } from 'antd';

export const DrawerWrapper = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 692px !important;
  }
  .ant-drawer-mask {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .anticon-close {
    font-size: 25px;
  }
  .ant-drawer-maskblockpop {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
  }
  .ant-drawer-close{
    width: 25px !important;
    height: 25px !important;
    position: relative;
    float: right;
    margin-top: 25px;
    margin-right: 25px;
    line-height:1
    @media only screen and (max-width: 991px) {
      padding-top: 2px;
    }
  }
  .ant-drawer-body {
    padding: 60px 80px 40px 80px;
  }
  .needAssistance-confirm + div{
    position:fixed;
    bottom:40px;
  }
  @media only screen and (max-width: 991px) {
    .ant-drawer-content-wrapper {
      width: 100% !important;
      height: 100% !important;
      overflow-y: scroll;
    }
    .ant-drawer-body {
      background-color: white;
      padding: 40px 23px 30px 22px !important;
    }
  }`

  export const ContactPara = styled.p`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #505050;
  margin: 0px;
  @media only screen and (max-width: 991px) {
    font-size: 14px;
    line-height: 1.43;
  }
`

export const BottomHeader = styled.h3`
  line-height: 1.25;
  letter-spacing: 0.5px;  
  font-size: 24px;
  color: #022737;
  font-family: BerkeleyStd-Book;
  margin-bottom: 15px;
  @media only screen and (max-width: 991px) {
    margin-bottom: 5px;
    font-size: 20px;
    line-height: 1.5;
  }
`
export const NeedAssistanceFooter = styled.div`  
`
